export const defaultState = () => {
  return {
  };
};

const state = defaultState();

export default state;
